import React from "react";
import PropTypes from "prop-types";
import { Button, Card, CardTitle, Avatar, CardActions, FontIcon } from "react-md";

const styleDiv = { display: "contents" };
const styleCard = { maxWidth: 320, display: "inline-block", verticalAlign: "top" };
class ButtonCard extends React.Component {
    constructor() {
        super();
        this.click = this.click.bind(this);
    }
    
    click() {
        if (this.props.pathname.startsWith("http")) {
            window.open(this.props.pathname, "_blank");
        } else {
            this.props.history.push({ pathname: this.props.pathname });
        }
    }

    render() {
        return (
            <div className={this.props.className} style={styleDiv}>
                <Card style={styleCard} className="md-cell md-cell--6 md-cell--8-tablet" raise={true}>
                    <CardTitle
                        title={this.props.title}
                        subtitle={this.props.subTitle}
                        avatar={<Avatar icon={<FontIcon>{this.props.icon}</FontIcon>} />}
                    />
                    <CardActions style={{ minHeight: 70 }}>
                        <Button flat onClick={this.click}>{this.props.actionName}</Button>
                    </CardActions>
                </Card>
            </div>
        );
    }
}

ButtonCard.propTypes = {
    actionName: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    pathname: PropTypes.string.isRequired,
};

export default ButtonCard;